module.exports = "/assets/founders-placeholder@2x.jpg?xjKyjxK";